export default "__VITE_ASSET__5708d3d7__"